import { Component, OnInit } from '@angular/core';
import { AveriasService } from '../servicios/averias.service';
import { Clasificacion } from '../entidades/entidades.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent} from '../snack-bar/snack-bar.component';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { DatePipe } from '@angular/common';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
@Component({
    selector: 'app-clasificacion',
    templateUrl: './clasificacion.component.html',
    styleUrls: ['./clasificacion.component.css'],
    standalone: true,
    imports: [FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,MatCardModule,MatFormFieldModule,MatInputModule,SpinnerComponent,AngularSlickgridModule,NbTabsetModule],
})
export class ClasificacionComponent implements OnInit {
  durationInSeconds = 3;
  firstForm: UntypedFormGroup;
  checked = false;
  clasificacion: SelectItem[];
  clasificacionOK = false;
  IdClasificacion: number;
  showClasificacion = false
  clasificacionProcesada;
  descripcionClasificacion;
  descripcionBreve;
  codigoExterno;
  clasificacionCompleta;
  descripcionBreveEditar;
  descripcionClasificacionEditar;
  codigoExternoEditar;
  datasetClasificacion: any[] = [];
  angularGridClasificacion: AngularGridInstance;
  datasetClasificacionConsulta: any[] = [];
  angularGridClasificacionConsulta: AngularGridInstance;
  showSpinner = false;
  columnDefinitionsClasificacion: Column[];
  gridOptionsClasificacion: GridOption;
  columnDefinitionsClasificacionConsulta: Column[];
  gridOptionsClasificacionConsulta: GridOption;
  gridObjClasificacion: any;
  showGrilla = false;
  showGrillaConsulta = false;
  showSpinnerGuardar = false;
  showSpinnerModificar = false;
  showSpinnerConsulta = false;
  idCliente:number;
  eliminar = false;
  eliminarSeleccionado;
  constructor(private fb: UntypedFormBuilder, private AveriasService: AveriasService, private _snackBar: MatSnackBar, private dateFormatter:DatePipe,public usersRol: PerfilesUsuarioService) { }

  ngOnInit(): void {
    this.idCliente = Number( localStorage.getItem("idCliente"));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });

  }

  ngAfterViewInit():void {
    
  }

  onChangeTab(event){
    if(event.tabTitle == "Alta"){
      this.consultarClasificacion();
    }
    if(event.tabTitle == "Consulta"){
      this.consultarClasificacionConsulta();
    }
    if(event.tabTitle == "Modificación"){
      this.consultarClasificacionModificar();
    }
  }

  toggleEliminar(eliminar: boolean) {
    this.eliminar = eliminar;
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  consultarClasificacion() {
    this.showSpinner = true;
    this.showGrilla = false;
    this.AveriasService.getClasificacion(this.idCliente).subscribe(
      data => {
        this.clasificacionCompleta = data;
        this.clasificacion = this.insertarClasificacion(data);
        this.traerDatosClasificacion();
        this.fillGrillaClasificacion();
      });
  }
  consultarClasificacionConsulta() {
    this.showSpinnerConsulta = true;
    this.showGrillaConsulta = false;
    this.AveriasService.getClasificacion(this.idCliente).subscribe(
      data => {
        this.clasificacionCompleta = data;
        this.traerDatosClasificacionConsulta();
        this.fillGrillaClasificacionConsulta();
      });
  }
  consultarClasificacionModificar() {
    this.AveriasService.getClasificacion(this.idCliente).subscribe(
      data => {
        this.clasificacionCompleta = data;
        this.clasificacion = this.insertarClasificacion(data);
      });
  }
  insertarClasificacion(armarClasificacion) {
    let averiasClasificacion: Array<any> = [];
    armarClasificacion.content.forEach(element => {
      averiasClasificacion.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasClasificacion;
  };
  capturarClasificacion(event) {
    this.IdClasificacion = event;
    this.clasificacionOK = true;
  }
  altaClasificacion() {
    let clasificacion: Clasificacion;

    if (this.descripcionClasificacion == null || this.descripcionClasificacion == "") {
      this.openSnackBar("Debe Completar la Descripción ❌");
    } else if (this.descripcionBreve == null || this.descripcionBreve == "") {
      this.openSnackBar("Debe Completar la Descripción Breve ❌");
    } else if (this.codigoExterno == null || this.codigoExterno == "") {
      this.openSnackBar("Debe Completar el Código Externo ❌");
    } else {
      clasificacion = {
        descripcion: this.descripcionClasificacion,
        descripcionAbreviada: this.descripcionBreve,
        codigoExterno: this.codigoExterno,
        idCliente: this.idCliente,
      }
      this.showSpinnerGuardar = true;
      this.AveriasService.postClasificacion(clasificacion).subscribe(data => {
        if(data["status"] == 201){
          this.openSnackBar('Los cambios se han guardado correctamente');
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.descripcionClasificacion = '';
        this.descripcionBreve = '';
        this.codigoExterno = '';
        this.consultarClasificacion();
        this.showSpinnerGuardar = false;
      })
    }

  }
  modificarClasificacion() {
    let clasificacion: Clasificacion ; 

    if (this.eliminar) {
      this.AveriasService.deleteClasificacion(this.clasificacionProcesada).subscribe(data => {
        if (data["status"] == 204) {
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.descripcionClasificacionEditar = '';
          this.descripcionBreveEditar = '';
          this.codigoExternoEditar = '';
          this.clasificacionProcesada = '';
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.eliminarSeleccionado = false;
        this.eliminar = false;
        this.consultarClasificacionModificar();
      })
    } else {

      if (this.descripcionClasificacionEditar == null || this.descripcionClasificacionEditar == "") {
        this.openSnackBar("Debe Completar la Descripción ❌");
      } else if (this.descripcionBreveEditar == null || this.descripcionBreveEditar == "") {
        this.openSnackBar("Debe Completar la Descripción Breve ❌");
      } else if (this.codigoExternoEditar == null || this.codigoExternoEditar == "") {
        this.openSnackBar("Debe Completar el Código Externo ❌");
      } else {
        this.showSpinnerModificar = true;
        clasificacion = {
          descripcion: this.descripcionClasificacionEditar,
          descripcionAbreviada: this.descripcionBreveEditar,
          codigoExterno: this.codigoExternoEditar,
          idCliente: this.idCliente,
      }
      this.AveriasService.putClasificacion(this.clasificacionProcesada, clasificacion).subscribe(data =>{
        if(data["status"] == 200){
          this.openSnackBar('Los cambios se han guardado correctamente');
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.showSpinnerModificar = false;
        this.eliminarSeleccionado = false;
        this.eliminar = false;
        this.consultarClasificacionModificar();
      })
      this.descripcionClasificacionEditar = '';
      this.descripcionBreveEditar = '';
      this.codigoExternoEditar = '';
      this.clasificacionProcesada = '';
      
      }
    }
  }
  obtenerDescripcionDropdown(IdClasificacion: number) {
    let resp = this.clasificacionCompleta.content.find(n => n['id'] == IdClasificacion);
    this.descripcionBreveEditar = resp['descripcionAbreviada'];
    this.descripcionClasificacionEditar = resp['descripcion'];
    this.codigoExternoEditar = resp['codigoExterno'];
    this.eliminarSeleccionado = false;
  }
  //Grilla Clasificacion
  traerDatosClasificacion() {
      let DatosClasificacion = this.clasificacionCompleta['content'];
      let mockDataset : any = [];
      for (let i = 0; i < DatosClasificacion.length; i++) {
      mockDataset.push({
        id: DatosClasificacion[i]["id"],
        Descripcion: DatosClasificacion[i]["descripcion"],
        DescripcionAbreviada: DatosClasificacion[i]["descripcionAbreviada"],
        Codigo: DatosClasificacion[i]["codigoExterno"],
      });
    }
      this.datasetClasificacion  = mockDataset;
      this.showSpinner = false;
      this.showGrilla = true;
  }

  traerDatosClasificacionConsulta() {
    let DatosClasificacion = this.clasificacionCompleta['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosClasificacion.length; i++) {
    mockDataset.push({
      id: DatosClasificacion[i]["id"],
      Descripcion: DatosClasificacion[i]["descripcion"],
      DescripcionAbreviada: DatosClasificacion[i]["descripcionAbreviada"],
      Codigo: DatosClasificacion[i]["codigoExterno"],
    });
  }
    this.datasetClasificacionConsulta  = mockDataset;
    this.showSpinnerConsulta = false;
    this.showGrillaConsulta = true;
}
  fillGrillaClasificacion() {
    this.columnDefinitionsClasificacion = [
      { id: 'Descripcion', name: 'Descripción', field: 'Descripcion', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'DescripcionAbreviada', name: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'Codigo', name: 'Código', field: 'Codigo', sortable: true, filterable: true, minWidth: 40, width: 40},
    ];
    this.gridOptionsClasificacion = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  fillGrillaClasificacionConsulta() {
    this.columnDefinitionsClasificacionConsulta = [
      { id: 'Descripcion', name: 'Descripción', field: 'Descripcion', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'DescripcionAbreviada', name: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filterable: true, minWidth: 100, width: 100},
      { id: 'Codigo', name: 'Código', field: 'Codigo', sortable: true, filterable: true, minWidth: 40, width: 40},
    ];
    this.gridOptionsClasificacionConsulta = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }
  angularGridReadyClasificacion(angularGrid: AngularGridInstance){
    this.angularGridClasificacion = angularGrid;
    this.angularGridClasificacion.resizerService.pauseResizer(false)
  }
  angularGridReadyClasificacionConsulta(angularGrid: AngularGridInstance){
    this.angularGridClasificacionConsulta = angularGrid;
    this.angularGridClasificacionConsulta.resizerService.pauseResizer(false)
  }

  exportToExcelClasificacion() {
    (this.angularGridClasificacionConsulta as any).excelExportService.exportToExcel({
      filename: 'Clasificación_' + this.dateFormatter.transform(new Date(), "dd-MM-yyyy"),
      format: FileType.xlsx
    });
  }
}
